import RetencionesMasivasFilesUploadStore from './RetencionesMasivasFilesUploadStore';
import RetencionesMasivasFilesListStore from './RetencionesMasivasFilesListStore';
import RetencionesMasivasTicketsListStore from './RetencionesMasivasTicketsListStore';
import RetencionesMasivasTicketsInfoStore from './RetencionesMasivasTicketsInfoStore';

const RetencionesMasivasStore = {
  files: {
    list: RetencionesMasivasFilesListStore,
    upload: RetencionesMasivasFilesUploadStore,
  },
  tickets: {
    list: RetencionesMasivasTicketsListStore,
    info: RetencionesMasivasTicketsInfoStore,
  },
};

export default RetencionesMasivasStore;
